import MuiFormControlLabel, {
  FormControlLabelProps
} from '@mui/material/FormControlLabel';

export interface IFormControlLabelProps extends FormControlLabelProps {}

const FormControlLabel = (props: IFormControlLabelProps): JSX.Element => {
  return <MuiFormControlLabel {...props}
  labelPlacement={props.labelPlacement === undefined ? "top": props.labelPlacement} />;
};

export default FormControlLabel;

